<div class="col-md-8 col-md-offset-1" *ngIf="!bookingInit || !copyLoaded">
  <div class="loader-container">
    <div class="loader">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" />
      </svg>
    </div>
  </div>
</div>

<div class="col-md-8 col-md-offset-1" *ngIf="bookingInit">

  <div>
    <app-language-selector></app-language-selector>
    <button id="collection-back" type="button" class="btn btn-link hidden-sm hidden-xs back-btn"
      *ngIf="bookingType !== 'amend'" (click)="goBack()">
      <i class="icon">chevron_left</i>{{ appCopy.panelHeader['backLink'+selectedLanguage] }}
    </button>
  </div>
</div>

<section class="col-md-8 col-md-offset-1 fadeInUp" *ngIf="bookingInit">
  <ng-container *ngIf="showUpsellCCD === true">
    <div class="modal-wrapper">
      <h1 class="margin-bottom-16 text-dark-blue">{{ userSelectedServicetype === 'd2d'? appCopy.panelHeader['d2dTitle'+selectedLanguage] : appCopy.panelHeader['upsellTitle'+selectedLanguage] }}</h1>
      <p>{{ userSelectedServicetype === 'd2d'? appCopy.panelHeader['d2dContent'+selectedLanguage].replace('%s', arrivalCityName) : appCopy.panelHeader['upsellContent'+selectedLanguage].replace('%s', arrivalCityName) }}</p>
      <div class="card">
        <div class="card-body">
          <div class="details">
            <b>{{lastLegAirlineCode}}{{lastLegAirlineNumber}}</b>
            <p>{{lastLegAirportCode}} {{ appCopy.panelHeader['arrival'+selectedLanguage] }}</p>
          </div>
          <div class="center-image">
            <img [src]="userSelectedServicetype === 'd2d' ? 'images/carousel.svg' : 'images/car.svg'" alt="upsell service image">
          </div>
          <div class="details">
            <b>{{ appCopy.panelHeader['yourAddress'+selectedLanguage] }}</b>
            <p>{{ appCopy.panelHeader['homeHotelOffice'+selectedLanguage] }}</p>
          </div>
        </div>
        <div class="card-right">
          <p>{{ appCopy.panelHeader['from'+selectedLanguage] }}</p>
          <b>+{{upsellCheapestPrice}}</b>
        </div>
      </div>
      <div class="info-block" *ngIf="isMultiLeg === true">
        <div class="info-icon">
          <i class="icon-information"></i>
        </div>
        <div class="info-message">
          <p>{{ appCopy.panelHeader['upsellMutliLegMessage'+selectedLanguage].replace('%s',
            (lastLegAirlineCode+lastLegAirlineNumber)) }}</p>
        </div>
      </div>
    </div>

    <ng-container *ngIf="userSelectedServicetype !== 'd2d'">
      <button id="formBagPickupTimeDate-submit" type="button" style="background-color: #7850FA;color: white;"
        class="btn btn-block margin-bottom-24" (click)="upsellHandler(true)">
        {{ appCopy.panelHeader['findMore'+selectedLanguage] }}
      </button>
      <button id="formBagPickupTimeDate-submit" type="button"
        style="background-color: transparent;color: #7850FA;border: solid 1px #7850FA;"
        class="btn btn-block margin-bottom-24" (click)="cancel()">
        {{ appCopy.panelHeader['carryBags'+selectedLanguage] }}
      </button>
    </ng-container>
    <button *ngIf="userSelectedServicetype === 'd2d'" id="formBagPickupTimeDate-submit" type="button" style="background-color: #7850FA;color: white;"
      class="btn btn-block margin-bottom-24" (click)="upsellHandler(true)">
      {{ appCopy.panelHeader['d2dButton'+selectedLanguage] }}
    </button>
  </ng-container>
  <ng-container *ngIf="showUpsellABC === true">
    <div class="modal-wrapper">
      <h1 class="margin-bottom-16 text-dark-blue">{{ appCopy.panelHeader['upsellTitle'+selectedLanguage] }}</h1>
      <p>{{ appCopy.panelHeader['upsellContent'+selectedLanguage] }}</p>
      <div class="card">
        <div class="card-body">
          <div class="details">
            <b>{{ appCopy.panelHeader['yourAddress'+selectedLanguage] }}</b>
            <p>{{ appCopy.panelHeader['homeHotelOffice'+selectedLanguage] }}</p>
          </div>
          <div class="center-image">
            <img src="images/car.svg" alt="upsell service image">
          </div>
          <div class="details">
            <b>{{originalAirlineCode}}{{flightNumber}}</b>
            <p>{{departureAirlineCode}} {{ appCopy.panelHeader['departure'+selectedLanguage] }}</p>
          </div>
        </div>
        <div class="card-right">
          <p>{{ appCopy.panelHeader['from'+selectedLanguage] }}</p>
          <b>+{{upsellCheapestPrice}}</b>
        </div>
      </div>
      <div class="info-block" *ngIf="isMultiLeg === true">
        <div class="info-icon">
          <i class="icon-information"></i>
        </div>
        <div class="info-message">
          <p>{{ appCopy.panelHeader['upsellMutliLegMessage'+selectedLanguage].replace('%s',
            (lastLegAirlineCode+lastLegAirlineNumber)) }}</p>
        </div>
      </div>
    </div>

    <button id="formBagPickupTimeDate-submit" type="button" style="background-color: #7850FA;color: white;"
      class="btn btn-block margin-bottom-24" (click)="upsellHandler(true)">
      {{ appCopy.panelHeader['findMore'+selectedLanguage] }}
    </button>
    <button id="formBagPickupTimeDate-submit" type="button"
      style="background-color: transparent;color: #7850FA;border: solid 1px #7850FA;"
      class="btn btn-block margin-bottom-24" (click)="cancel()">
      {{ appCopy.panelHeader['carryBags'+selectedLanguage] }}
    </button>
  </ng-container>

</section>
